import { API_BASE_URL, FAILURE, POST, GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionExcelImportarMobileOperator(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-mobile-operator/create-configuracion-importar-excel-mobile-operator",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionExcelImportarMobileOperator err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionExcelImportarMobileOperator() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-mobile-operator/obtener-configuracion-importar-excel-mobile-operator",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionExcelImportarMobileOperator err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionExcelImportarMobileOperator(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-mobile-operator/actualizar-configuracion-importar-excel-mobile-operator",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionExcelImportarMobileOperator err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImportarExcelMobileOperator(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-mobile-operator/guardar-importar-excel-mobile-operator",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImportarExcelMobileOperator err");
        console.log(err);
        return { error: true, message: err };
    }
}
